/* eslint-disable prettier/prettier */
import axios from 'axios'
import {
    DateTimeFormat
} from '../../helpers/momentFormat'

const state = {
    poDeliveries: {},
    poDelivery: {},
    isLoadingTable: false,
    showDeleteModal: false
}

const mutations = {
    getPaginatedData(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/podeliveries/page=${payload.page}&pageSize=${payload.pageSize}/${payload.query}`).then(response => {
            response.data.data.forEach(d => {
                d.dateUpdated = DateTimeFormat(d.dateUpdated)
            })
            state.poDeliveries = response.data
            // eslint-disable-next-line no-console
        }).catch(error => console.log(error)).then(() => state.isLoadingTable = false)
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.poDelivery) {
            state.poDelivery = payload.poDelivery
        } else {
            state.poDelivery = {}
        }
    }
}

const actions = {
    getPaginatedData({
        commit
    }, payload) {
        commit('getPaginatedData', payload)
    },
    openDeleteModal({
        commit
    }, payload) {
        commit('openDeleteModal', payload)
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions
}